import {Icon} from '@github-ui/pacer/Icon'
import {TriangleDownIcon} from '@primer/octicons-react'
import React from 'react'

import styles from './StarterPill.module.css'

type StarterPillProps = {
  testId: string
  name: string
  icon: string
  color: string
  onClick: () => void
  dropdown?: boolean
  open?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

export const StarterPill = ({ref, testId, name, icon, color, onClick, dropdown, open}: StarterPillProps) => {
  return (
    <button
      ref={ref}
      className={styles.container}
      onClick={onClick}
      aria-expanded={open}
      data-testid={`starter-${testId}`}
    >
      {Icon && (
        <div className={styles.icon}>
          <Icon icon={icon} color={color} />
        </div>
      )}
      <div className={styles.title}>
        {name}
        {dropdown && (
          <div className={styles.dropdown}>
            <TriangleDownIcon />
          </div>
        )}
      </div>
    </button>
  )
}

StarterPill.displayName = 'StarterPill'
